import { createReducer, on } from '@ngrx/store';
import { UiActions } from './ui.actions';
import { CareActions } from '@app/store/care/care.actions';
import { AuthActions } from '@app/store/auth/auth.actions';
import { UiState, initialUiState } from './models/ui-state.models';

/**
 * UI Reducer
 * 
 * Handles all state transitions for UI features
 */
export const uiReducer = createReducer(
  initialUiState,
  
  // ========== Sidenav Actions ==========
  on(UiActions.toggleSidenav, (state) => ({
    ...state,
    sidenav: {
      isOpen: !state.sidenav.isOpen
    }
  })),
  
  on(UiActions.openSidenav, (state) => ({
    ...state,
    sidenav: {
      isOpen: true
    }
  })),
  
  on(UiActions.closeSidenav, (state) => ({
    ...state,
    sidenav: {
      isOpen: false
    }
  })),
  
  on(UiActions.showGlobalLoading, CareActions.loadCareRecipients, CareActions.revokeLink, AuthActions.logout, (state) => ({
    ...state,
    globalLoading: true
  })),
  
  on(UiActions.hideGlobalLoading, CareActions.loadCareRecipientsSuccess, CareActions.loadCareRecipientsFailure, CareActions.revokeLinkSuccess, CareActions.revokeLinkFailure, (state) => ({
    ...state,
    globalLoading: false
  }))
);
